var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sticky-cart insicht insicht--fade-in",
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.onClick.apply(null, arguments)
        }
      }
    },
    [
      _vm.hasBasket
        ? _c("div", { staticClass: "sticky-cart__summary" }, [
            _c(
              "div",
              { staticClass: "sticky-cart__summary-icon" },
              [
                _c("SVGBag"),
                _vm._v(" "),
                _vm.totalItemsWithoutAdditional
                  ? _c("span", {
                      staticClass: "sticky-cart__summary-icon-count",
                      domProps: {
                        innerHTML: _vm._s(_vm.totalItemsWithoutAdditional)
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "sticky-cart__summary-details" }, [
              _c("span", {
                staticClass: "sticky-cart__summary-total",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$options.filters.fwgpricecent(_vm.displayTotal, "short")
                  )
                }
              }),
              _vm._v(" "),
              _vm.deliveryPrice
                ? _c("span", {
                    staticClass: "sticky-cart__summary-shipping",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("cart.deliveryFeePrice", {
                          price: _vm.$options.filters.fwgpricecent(
                            _vm.deliveryPrice,
                            "short"
                          )
                        })
                      )
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.deliveryPrice && _vm.minCartFreePrice
                ? _c("span", {
                    staticClass: "sticky-cart__summary-shipping-min",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("cart.freeDeliveryThreshold", {
                          price: _vm.$options.filters.fwgpricecent(
                            _vm.minCartFreePrice,
                            "short"
                          )
                        })
                      )
                    }
                  })
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("Button", {
        staticClass: "sticky-cart__button",
        attrs: {
          type: "button",
          level: "primary",
          text: _vm.hasBasket
            ? _vm.$t("cart.stickyCartButton")
            : _vm.$t("cart.stickyCartStartOrder")
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }